import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteJournalEntryLines', {
    accountColumnName: 'Account',
    accountFieldPlaceholder: 'Select account',
    debitAmountColumnName: 'Debit amount',
    defaultInputPlaceholder: 'Enter value',
    creditAmountColumnName: 'Credit amount',
    taxCodeColumnName: 'Tax code',
    taxCodeFieldPlaceholder: 'Select tax code',
    taxRateColumnName: 'Tax rate',
    taxAmountColumnName: 'Tax amount',
    grossAmountColumnName: 'Gross amount',
    grossAmountFieldPlaceholder: 'Enter gross amount',
    taxAccountColumnName: 'Tax account',
    taxAccountFieldPlaceholder: 'Select tax account',
    memoColumnName: 'Memo',
    memoFieldPlaceholder: 'Enter memo',
    departmentColumnName: 'Department',
    departmentFieldPlaceholder: 'Select department',
    classColumnName: 'Class',
    classFieldPlaceholder: 'Select class',
    locationColumnName: 'Location',
    locationFieldPlaceholder: 'Select location',
    datePlaceholder: 'Select date',
    amortizationSchedule: 'Amortization Schedule',
    amortizationStartDate: 'Amortization Start Date',
    amortizationEndDate: 'Amortization End Date',
    amortizationResidual: 'Amortization Residual',
    customerColumnName: 'Customer',
    customerFieldPlaceholder: 'Select value',
    sectionName: 'Lines',
    groupEdit: 'Edit selected',
    groupClone: 'Clone selected',
    groupRemove: 'Remove selected',
});
